(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/react-container.js') >= 0) return;  svs.modules.push('/modules/player-registration/react-container.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_registration=_svs.player_registration||{};
_svs.player_registration.templates=_svs.player_registration.templates||{};
svs.player_registration.templates.react_container = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"react-container-registration\" class=\"bg-white f-body line-height-150 react-container-registration\"></div>\n";
},"useData":true});
Handlebars.partials['svs-player_registration-react_container'] = svs.player_registration.templates.react_container;
})(svs, Handlebars);


 })(window);